import { FormProvider, useForm } from "react-hook-form";
import { useContext, useEffect, useState } from "react";

import { IStockTakingsModel } from "../models/IStockTakingsModel";
import { useFetchStockTakings } from "../hooks/fetchDocument";
import { NewDocumentModalViewContext } from "src/components/Shared/NewDocumentModalView";
import { AccountTypeEnum } from "src/enums/Accounting/AccountTypeEnum";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFTab } from "src/components/Shared/NewForms/NFTab";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { StockTakingsDetailMain } from "./StockTakingsDetailMain";
import { StockTakingsDetailProducts } from "./StockTakingsDetailProducts";
import { StockTakingsDetailAdditional } from "./StockTakingsDetailAdditional";
import { StockTakingsDetailFooter } from "./StockTakingsDetailFooter";

interface IProps {
  id?: string;
}

export const StockTakingsDetail = ({ id }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<IStockTakingsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Stock takings");

  const accountTypes: { id: number; name: string }[] = [
    { id: AccountTypeEnum.Active, name: "Active" },
    { id: AccountTypeEnum.Passive, name: "Passive" },
    { id: AccountTypeEnum.ActivePassive, name: "ActivePassive" }
  ];

  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchStockTakings({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };
  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.StockTakings.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handlePost} />
          <DetailViewCancelButton onCancel={handleCancel} />
          {/*<DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel}*/}
          {/*                              fileName={fileName} setFileName={setFileName}/>*/}
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <StockTakingsDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <StockTakingsDetailProducts />
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <StockTakingsDetailAdditional />
        </NFTabContainer>
      </div>
      <StockTakingsDetailFooter />
    </FormProvider>
  );
};
